import { render } from "./referrals.vue?vue&type=template&id=45548476&ts=true"
import script from "./referrals.vue?vue&type=script&lang=ts"
export * from "./referrals.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__